// extracted by mini-css-extract-plugin
export default {"block":"ProgressBar_block__-mjOi","progress":"ProgressBar_progress__T0wZ4"};